import { convertIdsToEntities } from '../../../utils';

import { EventInfo, AssociatedEntity } from '../../../domain';

export const getAssociatedEntityName = (
  event: EventInfo,
  allLists: AssociatedEntity[],
  allChannels: AssociatedEntity[],
  allMessageTypes: AssociatedEntity[],
) => {
  const listsForEvent = convertIdsToEntities(event.emailListIds ?? [], allLists);
  if (listsForEvent.length > 0) return listsForEvent[0].name;

  const channelsForEvent = convertIdsToEntities(event.channelIds ?? [], allChannels);
  if (channelsForEvent.length > 0) return channelsForEvent[0].name;

  const messageTypesForEvent = convertIdsToEntities(event.messageTypeIds ?? [], allMessageTypes);
  if (messageTypesForEvent.length > 0) return messageTypesForEvent[0].name;
};
